var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconUpdateAvatar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0701 23.5H19.9301C22.0001 23.5 22.8251 22.2325 22.9226 20.6875L23.3126 14.4925C23.4176 12.8725 22.1276 11.5 20.5001 11.5C20.0426 11.5 19.6226 11.2375 19.4126 10.8325L18.8726 9.745C18.5276 9.0625 17.6276 8.5 16.8626 8.5H15.1451C14.3726 8.5 13.4726 9.0625 13.1276 9.745L12.5876 10.8325C12.3776 11.2375 11.9576 11.5 11.5001 11.5C9.87263 11.5 8.58263 12.8725 8.68763 14.4925L9.07763 20.6875C9.16763 22.2325 10.0001 23.5 12.0701 23.5Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 13H17.125",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5C17.3425 20.5 18.4375 19.405 18.4375 18.0625C18.4375 16.72 17.3425 15.625 16 15.625C14.6575 15.625 13.5625 16.72 13.5625 18.0625C13.5625 19.405 14.6575 20.5 16 20.5Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconUpdateAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-update-avatar.af4214474588e48f90b534b05710d7bc.svg";